import { AccentVariantEnum } from '@delmonicos/shared-design-system-react/src/components/accent-icon/accent-icon';
import { Accordion } from '@delmonicos/shared-design-system-react/src/components/accordion/accordion';
import { NumberFixed } from '@delmonicos/shared-design-system-react/src/components/number-fixed/number-fixed';
import {
  GapEnum,
  Stack,
} from '@delmonicos/shared-design-system-react/src/components/stack/stack';
import {
  Text,
  TextFontSize,
} from '@delmonicos/shared-design-system-react/src/components/typography/text/text';
import { AccentTitle } from '@delmonicos/shared-design-system-react/src/components/typography/title/accent-title/accent-title';
import { HeadingEnum } from '@delmonicos/shared-design-system-react/src/models/enums/heading.enum';
import classNames from 'classnames';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { EnergyByMonthCard } from '@app/feature/statistics/energy-section/cards/energy-by-date.card';
import { EnergyByDayCard } from '@app/feature/statistics/energy-section/cards/energy-by-day.card';
import { EnergyByLocationCard } from '@app/feature/statistics/energy-section/cards/energy-by-location.card';
import { MoreLessEnergyChargePointCard } from '@app/feature/statistics/energy-section/more-less-energy-charge-point/more-less-energy-charge-point';
import {
  StatisticsAreaGranularityEnum,
  StatisticsTimeGranularityEnum,
} from '@model/enum/statistics-granularity.enum';
import { useCpmsBoGetEnergyDeliveredQuery } from '@service/cpms-bo-transaction-reports-energy-statistics.service';

import { useFilters } from '../context/filters.context';
import * as css from '../statistics.module.scss';
import { EnergyByConnectorTypeCard } from './cards/energy-by-connector-type.card';
import { EnergyByThirdPartyEndpointCard } from './cards/energy-by-third-party-endpoint.card';
import { EnergyDeliveredCard } from './cards/energy-delivered.card';

export const EnergySectionComponent = (): React.JSX.Element => {
  const { t } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);
  const {
    transformedFilters,
    filters: { areaGranularity, timeGranularity },
  } = useFilters();

  const { data } = useCpmsBoGetEnergyDeliveredQuery({ ...transformedFilters });

  const renderTitle = () => (
    <div className={css.accordionTitle}>
      <AccentTitle
        variant={AccentVariantEnum.Secondary}
        as={HeadingEnum.H2}
        icon="lightning-02"
        text={t('$.statistics.energy.title')}
      />
      <div className={classNames(css.energy, css.count)}>
        <NumberFixed
          bold
          fontSize={TextFontSize.Inherit}
          number={(data?.total ?? 0) / 1000}
          digits={0}
        />
        <Text bold>{t('$.statistics.energy.delivered.total-unit')}</Text>
      </div>
    </div>
  );

  return (
    <Accordion
      title={renderTitle()}
      isOpen={isOpen}
      onToggle={() => setIsOpen(true)}>
      <Stack gap={GapEnum.L} direction="column">
        <Stack gap={GapEnum.XL}>
          <EnergyDeliveredCard />
          <MoreLessEnergyChargePointCard />
        </Stack>
        <Stack gap={GapEnum.XL}>
          {areaGranularity !== StatisticsAreaGranularityEnum.Location &&
            areaGranularity !== StatisticsAreaGranularityEnum.ChargePoint && (
              <EnergyByLocationCard />
            )}
          {timeGranularity === StatisticsTimeGranularityEnum.Month ? (
            <EnergyByDayCard />
          ) : (
            <EnergyByMonthCard />
          )}
        </Stack>
        <Stack gap={GapEnum.XL}>
          <EnergyByThirdPartyEndpointCard />
          <EnergyByConnectorTypeCard />
        </Stack>
      </Stack>
    </Accordion>
  );
};
